import { Fragment } from 'react';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Icon } from '../../display/Icon';
import { Link } from '../../navigation/Link';
import { Button } from '../../navigation/Button';
import { Styles } from './ZapCard';
export const ZapCardCTA = (props) => {
    const { computedState, ariaHidden, href, isLink, target } = props;
    const ctaBody = isLink ? (isolateComponent(Fragment, null,
        isolateComponent(Link, { css: Styles.ctaLink(computedState), href: href, target: target, tabIndex: ariaHidden ? -1 : undefined },
            "Try it",
            isolateComponent("span", { css: Styles.ctaIcon(computedState) },
                isolateComponent(Icon, { isBlock: true, name: "arrowBigRight", size: 24 }))))) : (isolateComponent(Button, { href: props.href, target: target, tabIndex: ariaHidden ? -1 : undefined, size: "small" }, "Try it"));
    return (isolateComponent("div", { "aria-hidden": ariaHidden, css: Styles.ctaArea(computedState, props) }, ctaBody));
};
//# sourceMappingURL=ZapCardCTA.js.map
// @zapier/design-system@6.28.0 (14d5b99c8)
